export const INVALID_UUID = "aaaaaaaa-aaaa-aaaa-aaaa-aaaaaaaaaaaa";

export function extractUuids(
  text: string,
): [text: string | null, uuids: string[]] {
  let textSearch: string | null = text;
  const uuidRegex =
    /([a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}),? */g;
  let match;
  const uuids = [];
  // eslint-disable-next-line no-cond-assign
  while ((match = uuidRegex.exec(text)) !== null) {
    textSearch = textSearch.replace(match[0], "");
    uuids.push(match[1]);
  }
  textSearch = textSearch.trim() || null;
  return [textSearch, uuids];
}
